import '../sass/frontend.scss';

(function($){
    $(function(){

        // Show gift card input when link is clicked
        $('#swoo-show-gift-card').on('click', function() {
            $('#swoo-product-fields-pro .input-group').removeClass('hidden');
        });

        // Update gift card AJAX on shipping method click
        $('form.checkout').on('change', 'input[name^="shipping_method"]', function () {
            setTimeout(function() {
                updateGiftCardAjax(false);
            }, 1000);
        });

        $('#update_gift_card').on('click', function() {
            updateGiftCardAjax(true);
        });

        /**
         *
         * @param {boolean} reloadCheckout
         */
        function updateGiftCardAjax(reloadCheckout) {
            let giftCardCode = $('#swoo-product-fields-pro-input').val();
            $.ajax({
                type: 'POST',
                url: wc_checkout_params.ajax_url,
                data: {
                    action: 'update_gift_card',
                    gift_card_code: giftCardCode,
                    nonce: customAjaxParams.nonce,
                },
                success: (response) => {
                    const $balanceDiv = jQuery('#swoo-product-fields-pro-balance');
                    $balanceDiv.show();
                    if (response.success) {
                        jQuery('#swoo-product-fields-pro-balance-now').html(
                            response.data.balance_now
                        );
                        jQuery('#swoo-product-fields-pro-balance-after-purchase').html(
                            response.data.balance_after_purchase
                        );
                        jQuery('#swoo-product-fields-pro-amount-to-spend').html(
                            response.data.amount_to_spend
                        );
                        $balanceDiv.find('.error-box').hide();
                        $balanceDiv.find('.success-box').show();
                    } else if (giftCardCode.trim()) {
                        $balanceDiv.find('.success-box').hide();
                        $balanceDiv.find('.error-box').show();
                    }
                    if (reloadCheckout) {
                        jQuery('body').trigger('update_checkout');
                    }
                },
            });
        }

        // ==========================================
        // ISOLATED FIELD CONTROLLER CLASS (MAIN PRODUCT ONLY)
        // ==========================================
        class SwooProductFieldController {
            constructor($container) {
                this.$container = $container;
                this.basePrice = parseFloat(this.$container.data('base-price')) || 0;
                this.currency = this.$container.data('currency') || 'USD';
                this.locale = this.$container.data('locale') || 'en-US';

                try {
                    this.formatter = new Intl.NumberFormat(this.locale, {
                        style: 'currency',
                        currency: this.currency,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                    });
                } catch (e) {
                    this.formatter = {
                        format: (n) => {
                            return n % 1 === 0
                                ? n + ' ' + this.currency
                                : n.toFixed(2) + ' ' + this.currency;
                        }
                    };
                }

                this.init();
            }

            init() {
                this.setVisibleFields();

                this.$container.on('click', '.swoo-item', (e) => {
                    this.setVisibleFields($(e.currentTarget));
                });

                this.$container.on('change', 'select', () => {
                    this.setActiveClassesAsync().then(() => this.updateTotal());
                });

                this.$container.on('change input', 'select, input, textarea', (e) => {
                    this.setActiveClassesAsync().then(() => this.updateTotal());
                    const $fieldWrap = $(e.currentTarget).closest('.swoo-field');
                    if ($fieldWrap.length) clearFieldError($fieldWrap);
                });
            }

            parsePriceRaw(v) {
                if (v === undefined || v === null) return 0;
                if (typeof v === 'string') {
                    v = v.replace(/\s/g, '');
                    if (v.indexOf(',') > -1 && v.indexOf('.') === -1) v = v.replace(',', '.');
                    else if (v.indexOf(',') > -1 && v.indexOf('.') > -1 && v.indexOf(',') > v.indexOf('.')) v = v.replace(/\./g, '').replace(',', '.');
                    else v = v.replace(/,/g, '.');
                }
                const n = parseFloat(v);
                return isNaN(n) ? 0 : n;
            }

            getElementPrice($el) {
                let v = $el.data('price');
                if (typeof v === 'undefined' || v === null) v = $el.attr('data-price');
                return this.parsePriceRaw(v);
            }

            setActiveClassesAsync() {
                return new Promise((resolve) => {
                    this.$container.find('input[type="radio"], input[type="checkbox"]').each((_, el) => {
                        const $input = $(el);
                        const $item = $input.closest('.swoo-item');
                        $item.removeClass('swoo-active');
                        if ($input.is(':checked')) {
                            $item.addClass('swoo-active');
                        }
                    });
                    this.$container.find('select').each((_, el) => {
                        const $sel = $(el);
                        $sel.removeClass('swoo-has-selection');
                        if ($sel.find('option:selected').length) $sel.addClass('swoo-has-selection');
                    });
                    resolve();
                });
            }

            setVisibleFields($clickedItem = null) {
                return new Promise((resolve) => {
                    if ($clickedItem !== null) {
                        this.setActiveItem($clickedItem);
                    }

                    // Saml KUN data der eksisterer inde i denne specifikke controller ($container)
                    let values = {};
                    this.$container.find('.swoo-field-group').each((_, group) => {
                        let groupId = String($(group).data('group-id'));
                        values[groupId] = {};

                        $(group).find('.swoo-field').each((_, field) => {
                            let fIndex = String($(field).data('field-index'));
                            let activeLabels = [];

                            $(field).find('.swoo-item.swoo-active').each((_, activeItem) => {
                                let title = $(activeItem).find('.swoo-title, .swoo-option-label').first().text().trim();
                                if (!title) title = $(activeItem).find('.swoo-item-text').first().text().trim();
                                if (title) activeLabels.push(title.toLowerCase());
                            });

                            if (activeLabels.length === 0) {
                                $(field).find('input[type="radio"]:checked, select').each((_, input) => {
                                    let title = '';
                                    if ($(input).is('select')) {
                                        title = $(input).find('option:selected').text().split('(+')[0].trim();
                                    } else {
                                        title = $(input).closest('label').text().trim();
                                    }
                                    if (title) activeLabels.push(title.toLowerCase());
                                });
                            }

                            values[groupId][fIndex] = activeLabels;
                        });
                    });

                    // Evaluér felter baseret PÅ de indsamlede lokale data
                    this.$container.find('.swoo-field').each((_, field) => {
                        const $field = $(field);
                        let rulesStr = $field.attr('data-field-rules');
                        let rules = [];
                        if (rulesStr) {
                            try { rules = JSON.parse(rulesStr); } catch(e) { rules = $field.data('field-rules') || []; }
                        } else {
                            rules = $field.data('field-rules') || [];
                        }

                        if (rules.length === 0) {
                            $field.removeClass('swoo-hide');
                            return;
                        }

                        let shouldShow = false;
                        for (let i = 0; i < rules.length; i++) {
                            let r = rules[i];
                            let gId = String(r.group_id);
                            let fId = String(r.field_index);
                            let rVal = (r.value || '').trim().toLowerCase();

                            let currentVals = (values[gId] && values[gId][fId]) ? values[gId][fId] : [];

                            if (r.rule === 'equal') {
                                if (currentVals.includes(rVal)) {
                                    shouldShow = true;
                                    break;
                                }
                            } else if (r.rule === 'not_equal') {
                                if (!currentVals.includes(rVal)) {
                                    shouldShow = true;
                                    break;
                                }
                            }
                        }

                        if (shouldShow) {
                            $field.removeClass('swoo-hide');
                            if ($field.find('.swoo-item').length > 0 && $field.find('.swoo-item.swoo-active').length === 0) {
                                let $first = $field.find('.swoo-item').first();
                                $first.addClass('swoo-active');
                                $first.find('input[type="radio"], input[type="checkbox"]').prop('checked', true);
                            }
                        } else {
                            $field.addClass('swoo-hide');
                            $field.find('.swoo-item').removeClass('swoo-active').find('input').prop('checked', false);
                        }
                    });

                    this.$container.find('.swoo-field-group').each((_, group) => {
                        let hasVisibleRealFields = false;
                        $(group).find('.swoo-field:not(.swoo-hide):not(.swoo-field-html)').each(() => {
                            hasVisibleRealFields = true;
                        });
                        if (!hasVisibleRealFields) {
                            $(group).addClass('swoo-hide-group');
                        } else {
                            $(group).removeClass('swoo-hide-group');
                        }
                    });

                    resolve();
                });
            }

            setActiveItem($clickedItem) {
                const $input = $clickedItem.find('input').first();
                if (!$input.length) return;

                if ($input.is('[type="radio"]')) {
                    const name = $input.attr('name');
                    this.$container.find('input[name="' + name + '"]').each(function(){
                        $(this).closest('.swoo-item').removeClass('swoo-active');
                    });
                    $input.prop('checked', true);
                    $clickedItem.addClass('swoo-active');
                } else if ($input.is('[type="checkbox"]')) {
                    const checked = !$input.is(':checked');
                    $input.prop('checked', checked);
                    $clickedItem.toggleClass('swoo-active', checked);
                }
                $input.trigger('change');
            }

            updateTotal() {
                let total = this.basePrice;

                const $active = this.$container.find('.swoo-active').filter(function() {
                    const $this = $(this);
                    const $field = $this.closest('.swoo-field');
                    if (!$field.length) {
                        return $this.parents('.swoo-hide').length === 0;
                    }
                    return $field.length && !$field.hasClass('swoo-hide');
                });

                $active.each((_, el) => {
                    const $item = $(el);

                    $item.find('select option:selected').each((_, opt) => {
                        const $opt = $(opt);
                        if ($opt.closest('.swoo-field').hasClass('swoo-hide')) return;
                        total += this.getElementPrice($opt);
                    });

                    $item.find('input[type="radio"]:checked, input[type="checkbox"]:checked').each((_, inp) => {
                        const $inp = $(inp);
                        if ($inp.closest('.swoo-field').hasClass('swoo-hide')) return;
                        total += this.getElementPrice($inp);
                    });

                    $item.find('input[data-price], textarea[data-price]').each((_, inputEl) => {
                        const $el = $(inputEl);
                        if ($el.is(':radio') || $el.is(':checkbox')) return;
                        if ($el.closest('.swoo-field').hasClass('swoo-hide')) return;
                        const price = this.getElementPrice($el);
                        if ($el.is('[type="number"]') && $el.data('multiply')) {
                            const qty = parseFloat($el.val()) || 0;
                            total += price * qty;
                        } else {
                            if ($el.is('input[type="text"], textarea')) {
                                if ($el.val() !== '') total += price;
                            } else {
                                total += price;
                            }
                        }
                    });
                });

                $('#swoo-total-price').text(this.formatter.format(total));
            }
        }

        let globalProductId = $('.swoo-field-groups').first().data('product-id');

        function showFieldError($fieldEl, message){
            const $err = $fieldEl.find('.swoo-error');
            $err.text(message).show();
        }
        function clearFieldError($fieldEl){
            const $err = $fieldEl.find('.swoo-error');
            $err.text('').hide();
        }

        function getActiveContainer($container) {
            return $container.find('.swoo-active').filter(function() {
                const $this = $(this);
                const $field = $this.closest('.swoo-field');
                if (!$field.length) {
                    return $this.parents('.swoo-hide').length === 0;
                }
                return $field.length && !$field.hasClass('swoo-hide');
            });
        }

        // ISOLERING: Sørger for at main product logik KUN kører for formen i .summary
        $('.summary.entry-summary .swoo-field-groups').each(function() {
            new SwooProductFieldController($(this));
        });

        // ==========================================================
        // SUBMIT LOGIK - Sikrer vi KUN medsender formen i toppen!
        // ==========================================================
        $(document).on('submit', 'form.cart', function(e){
            const $form = $(this);
            // Ignorer alt hvad der ligger i .swoo-pg-container
            const $localContainer = $form.find('.swoo-field-groups').not('.swoo-pg-container .swoo-field-groups');
            if (!$localContainer.length) return true;

            const $activeContainer = getActiveContainer($localContainer);

            let valid = true;
            $activeContainer.find('.swoo-field').each(function(){
                const $wrap = $(this);
                const requiredInputs = $wrap.find('[data-required="1"]');
                if (!requiredInputs.length) return;
                if ($wrap.find('input[type="radio"]').length) {
                    if (!$wrap.find('input[type="radio"]:checked').length) {
                        valid = false;
                        showFieldError($wrap, $wrap.find('.swoo-field-label').text().trim() + ' is required.');
                    } else {
                        clearFieldError($wrap);
                    }
                } else if ($wrap.find('input[type="checkbox"]').length) {
                    if (!$wrap.find('input[type="checkbox"]:checked').length) {
                        valid = false;
                        showFieldError($wrap, $wrap.find('.swoo-field-label').text().trim() + ' is required.');
                    } else {
                        clearFieldError($wrap);
                    }
                } else if ($wrap.find('select').length) {
                    const $sel = $wrap.find('select');
                    if (!$sel.val() || $sel.val() === '') {
                        valid = false;
                        showFieldError($wrap, $wrap.find('.swoo-field-label').text().trim() + ' is required.');
                    } else {
                        clearFieldError($wrap);
                    }
                } else {
                    const $inp = $wrap.find('input, textarea').first();
                    if (!$inp.length) return;
                    if (!$inp.val() || $inp.val().toString().trim() === '') {
                        valid = false;
                        showFieldError($wrap, $wrap.find('.swoo-field-label').text().trim() + ' is required.');
                    } else {
                        clearFieldError($wrap);
                    }
                }
            });

            if (!valid) {
                e.preventDefault();
                const $firstError = $activeContainer.find('.swoo-error:visible').first();
                if ($firstError.length) $('html,body').animate({scrollTop: $firstError.offset().top - 80}, 250);
                return false;
            }
            return true;
        });

        $(document).on('click', '.single_add_to_cart_button', function(e){
            const $btn = $(this);
            const $form = $btn.closest('form.cart');
            if (!$form.length) return;
            const $localContainer = $form.find('.swoo-field-groups').not('.swoo-pg-container .swoo-field-groups');
            if (!$localContainer.length) return;

            const $activeContainer = getActiveContainer($localContainer);

            $form.find('.swoo-temp-input').remove();
            const serialized = $activeContainer.find(':input').filter(function(){ return !!$(this).attr('name') && !$(this).is(':disabled'); }).serializeArray();
            serialized.forEach(function(item){
                $('<input>')
                    .attr({'type':'hidden', 'name': item.name, 'value': item.value, 'class': 'swoo-temp-input'})
                    .appendTo($form);
            });
            setTimeout(function(){ $form.find('.swoo-temp-input').remove(); }, 2000);
        });

        $(document).on('click', 'a.single_add_to_cart_button, a.add_to_cart_button', function(e){
            const $btn = $(this);
            const $form = $btn.closest('form.cart');
            if ($form.length) return;
            const $localContainer = $('.swoo-field-groups[data-product-id="'+globalProductId+'"]').not('.swoo-pg-container .swoo-field-groups');
            if (!$localContainer.length) return;

            const $activeContainer = getActiveContainer($localContainer);

            const $tempForm = $('<form style="display:none" class="swoo-temp-form"></form>').appendTo('body');
            const serialized = $activeContainer.find(':input').filter(function(){ return !!$(this).attr('name') && !$(this).is(':disabled'); }).serializeArray();
            serialized.forEach(function(item){
                $('<input>')
                    .attr({'type':'hidden', 'name': item.name, 'value': item.value, 'class': 'swoo-temp-input'})
                    .appendTo($tempForm);
            });
            setTimeout(function(){ $tempForm.remove(); }, 2000);
        });

        $(document.body).on('adding_to_cart', function(event, $button, data){
            try {
                if (!$button || !$button.length) return;
                const $form = $button.closest('form.cart');
                let $local = $form.find('.swoo-field-groups').not('.swoo-pg-container .swoo-field-groups');
                if (!$local.length) {
                    $local = $('.swoo-field-groups[data-product-id="'+globalProductId+'"]').not('.swoo-pg-container .swoo-field-groups');
                }
                if (!$local.length) return;

                const $activeContainer = getActiveContainer($local);
                const serialized = $activeContainer.find(':input').filter(function(){ return !!$(this).attr('name') && !$(this).is(':disabled'); }).serializeArray();
                if (!serialized || serialized.length === 0) return;

                if (typeof data === 'string') {
                    const append = $.param(serialized);
                    data = (data.length ? (data + '&' + append) : append);
                    window.wc_swoo_last_extra = data;
                    return;
                }

                if (window.FormData && data instanceof FormData) {
                    serialized.forEach(function(pair){
                        data.append(pair.name, pair.value);
                    });
                    return;
                }

                if (typeof data === 'object' && data !== null) {
                    serialized.forEach(function(pair){
                        if (data.hasOwnProperty(pair.name)) {
                            if (!Array.isArray(data[pair.name])) {
                                data[pair.name] = [data[pair.name]];
                            }
                            data[pair.name].push(pair.value);
                        } else {
                            data[pair.name] = pair.value;
                        }
                    });
                    return;
                }

                window.wc_swoo_last_extra = $.param(serialized);
            } catch (err) {}
        });

        $.ajaxPrefilter(function(options, originalOptions, jqXHR){
            try {
                const url = (options.url || '').toString();
                const dataString = options.data && typeof options.data === 'string' ? options.data : '';
                const isWCAddToCartUrl = url.indexOf('wc-ajax=add_to_cart') > -1 || dataString.indexOf('add-to-cart=') > -1 || (options.data && (options.data['add-to-cart'] || options.data.add_to_cart));
                if (!isWCAddToCartUrl) return;

                const $local = $('.swoo-field-groups[data-product-id="'+globalProductId+'"]').not('.swoo-pg-container .swoo-field-groups');
                if (!$local.length) {
                    if (window.wc_swoo_last_extra && typeof options.data === 'string') {
                        options.data = options.data.length ? (options.data + '&' + window.wc_swoo_last_extra) : window.wc_swoo_last_extra;
                    }
                    return;
                }
                const serializedArray = $local.find(':input').filter(function(){ return !!$(this).attr('name') && !$(this).is(':disabled'); }).serializeArray();
                if (!serializedArray || serializedArray.length === 0) {
                    if (window.wc_swoo_last_extra && typeof options.data === 'string') {
                        options.data = options.data.length ? (options.data + '&' + window.wc_swoo_last_extra) : window.wc_swoo_last_extra;
                    }
                    return;
                }

                if (window.FormData && options.data instanceof FormData) {
                    serializedArray.forEach(function(pair){
                        options.data.append(pair.name, pair.value);
                    });
                    return;
                }

                if (typeof options.data === 'string') {
                    const append = $.param(serializedArray);
                    if (options.data.length) options.data = options.data + '&' + append;
                    else options.data = append;
                    return;
                }

                if (typeof options.data === 'object') {
                    const existing = $.param(options.data);
                    const append = $.param(serializedArray);
                    options.data = existing.length ? (existing + '&' + append) : append;
                    return;
                }

                options.data = $.param(serializedArray);
            } catch (err) {}
        });

        function buildSerializedPairsForContainer($local) {
            const pairs = [];
            if (!$local || !$local.length) return pairs;
            const $fields = $local.find('.swoo-field');
            $fields.each(function(){
                const $f = $(this);
                const cIndex = $f.attr('data-config-index');
                const fIndex = $f.attr('data-field-index');
                if (typeof cIndex === 'undefined' || typeof fIndex === 'undefined') return;

                const baseName = 'swoo_fields_submitted[' + encodeURIComponent(cIndex) + '][' + encodeURIComponent(fIndex) + ']';

                const $sel = $f.find('select').first();
                if ($sel.length) {
                    pairs.push({name: baseName, value: $sel.val() || ''});
                    return;
                }

                const $txt = $f.find('input[type="text"], input[type="number"], textarea, input[type="email"], input[type="tel"]').first();
                if ($txt.length) {
                    pairs.push({name: baseName, value: $txt.val() || ''});
                    return;
                }

                const $radios = $f.find('input[type="radio"]');
                if ($radios.length) {
                    const $checked = $radios.filter(':checked').first();
                    if ($checked.length) {
                        pairs.push({name: baseName, value: $checked.val()});
                    } else {
                        const $active = $f.find('.swoo-item.swoo-active input[type="radio"], .swoo-radio.swoo-active input[type="radio"]');
                        if ($active.length) pairs.push({name: baseName, value: $active.first().val()});
                        else pairs.push({name: baseName, value: ''});
                    }
                    return;
                }

                const $checks = $f.find('input[type="checkbox"]');
                if ($checks.length) {
                    const vals = [];
                    $checks.filter(':checked').each(function(){ vals.push($(this).val()); });
                    if (!vals.length) {
                        const $activeBoxes = $f.find('.swoo-checkbox.swoo-active, .swoo-item.swoo-active');
                        $activeBoxes.each(function(){
                            const v = $(this).find('input[type="checkbox"]').val();
                            if (typeof v !== 'undefined') vals.push(v);
                        });
                    }
                    if (!vals.length) {
                        pairs.push({name: baseName + '[]', value: ''});
                    } else {
                        vals.forEach(function(v){ pairs.push({name: baseName + '[]', value: v}); });
                    }
                    return;
                }

                const $activeFallback = $f.find('.swoo-item.swoo-active input, .swoo-active input').first();
                if ($activeFallback.length) {
                    pairs.push({name: baseName, value: $activeFallback.val() || ''});
                    return;
                }

                pairs.push({name: baseName, value: ''});
            });

            return pairs;
        }

        function mergePairIntoObject(obj, name, value) {
            const m = name.match(/^([^\[]+)((?:\[.*\])*)$/);
            if (!m) {
                obj[name] = value;
                return;
            }
            const root = m[1];
            const tail = m[2];

            const keys = [];
            const keyRegex = /\[([^\]]*)\]/g;
            let km;
            while ((km = keyRegex.exec(tail)) !== null) {
                keys.push(km[1]);
            }

            let cursor = obj;
            if (typeof cursor[root] === 'undefined') cursor[root] = {};
            cursor = cursor[root];

            for (let i = 0; i < keys.length; i++) {
                const k = keys[i];
                const isLast = (i === keys.length - 1);
                if (k === '') {
                    if (!Array.isArray(cursor)) {
                        if (Object.keys(cursor).length === 0) {
                            cursor = [];
                            obj[root] = cursor;
                        } else {
                            cursor = [];
                            obj[root] = cursor;
                        }
                    }
                    if (isLast) {
                        cursor.push(value);
                        return;
                    } else {
                        let next = {};
                        cursor.push(next);
                        cursor = next;
                        continue;
                    }
                } else {
                    if (!cursor.hasOwnProperty(k) || cursor[k] === null) {
                        cursor[k] = isLast ? value : {};
                    } else if (isLast) {
                        if (!Array.isArray(cursor[k])) {
                            cursor[k] = [cursor[k]];
                        }
                        cursor[k].push(value);
                        return;
                    }
                    if (!isLast) cursor = cursor[k];
                }
            }

            if (keys.length === 0) {
                obj[root] = value;
            }
        }

        (function(){
            if (!window.fetch) return;

            const origFetch = window.fetch;
            window.fetch = function(input, init) {
                try {
                    let url = (typeof input === 'string') ? input : (input && input.url) ? input.url : '';
                    const likelyAddToCartUrl = (url && (url.indexOf('wc-ajax=add_to_cart') > -1 || url.indexOf('add-to-cart=') > -1));
                    const initHasAddToCart = init && init.body && ( (init.body instanceof FormData) || (typeof init.body === 'string' && init.body.indexOf('add-to-cart=') > -1) );
                    const looksLikeAddToCart = likelyAddToCartUrl || initHasAddToCart;

                    if (!looksLikeAddToCart) {
                        if (!url || url.indexOf('add-to-cart') === -1) {
                            return origFetch.apply(this, arguments);
                        }
                    }

                    const $local = $('.swoo-field-groups[data-product-id="'+globalProductId+'"]').not('.swoo-pg-container .swoo-field-groups');
                    if (!$local.length) {
                        if (window.wc_swoo_last_extra) {
                            return origFetch.apply(this, arguments);
                        }
                        return origFetch.apply(this, arguments);
                    }

                    const pairs = buildSerializedPairsForContainer($local);
                    if (!pairs || pairs.length === 0) {
                        return origFetch.apply(this, arguments);
                    }

                    init = init || {};

                    if (window.FormData && init.body instanceof FormData) {
                        pairs.forEach(function(pair){ init.body.append(pair.name, pair.value); });
                        return origFetch.call(this, input, init);
                    }

                    if (typeof init.body === 'string' && init.body.indexOf('=') > -1) {
                        const append = pairs.map(p=> encodeURIComponent(p.name)+'='+encodeURIComponent(p.value)).join('&');
                        init.body = init.body.length ? (init.body + '&' + append) : append;
                        return origFetch.call(this, input, init);
                    }

                    let contentType = '';
                    if (init.headers) {
                        try {
                            if (typeof init.headers.get === 'function') {
                                contentType = init.headers.get('content-type') || init.headers.get('Content-Type') || '';
                            } else if (typeof init.headers === 'object') {
                                for (const h in init.headers) {
                                    if (!init.headers.hasOwnProperty(h)) continue;
                                    if (h.toLowerCase() === 'content-type') {
                                        contentType = init.headers[h];
                                        break;
                                    }
                                }
                            }
                        } catch (e) {}
                    }

                    const isJson = contentType && contentType.toLowerCase().indexOf('application/json') > -1;

                    if (init.body && typeof init.body === 'object' && !(init.body instanceof ArrayBuffer) && !(init.body instanceof Blob) && !(init.body instanceof FormData)) {
                        try {
                            if (typeof init.body === 'object') {
                                pairs.forEach(function(pair){
                                    mergePairIntoObject(init.body, pair.name, pair.value);
                                });
                                return origFetch.call(this, input, init);
                            }
                        } catch (e) {}
                    }

                    if (typeof init.body === 'string' && isJson) {
                        try {
                            const parsed = JSON.parse(init.body);
                            pairs.forEach(function(pair){
                                mergePairIntoObject(parsed, pair.name, pair.value);
                            });
                            init.body = JSON.stringify(parsed);
                            return origFetch.call(this, input, init);
                        } catch (e) {}
                    }

                    if (typeof input === 'string') {
                        const qappend = pairs.map(p=> encodeURIComponent(p.name)+'='+encodeURIComponent(p.value)).join('&');
                        input = input + (input.indexOf('?') === -1 ? '?' : '&') + qappend;
                    } else if (input && input.url) {
                        const qappend = pairs.map(p=> encodeURIComponent(p.name)+'='+encodeURIComponent(p.value)).join('&');
                        input = new Request(input.url + (input.url.indexOf('?') === -1 ? '?' : '&') + qappend, input);
                    }

                    return origFetch.call(this, input, init);
                } catch (e) {
                    return origFetch.apply(this, arguments);
                }
            };
        })();

        (function(){
            try {
                var observerTarget = document.querySelector('.summary.entry-summary') || document.body;
                if (!observerTarget) return;

                var isPopulating = false;

                var mo = new MutationObserver(function(mutations){
                    if (isPopulating) return;

                    let isRelevant = false;
                    for (let i = 0; i < mutations.length; i++) {
                        let m = mutations[i];
                        if (m.target && m.target.id === 'swoo-hidden-submitted') continue;
                        if (m.target && typeof m.target.className === 'string' && m.target.className.indexOf('swoo-submitted-temp') > -1) continue;
                        isRelevant = true;
                        break;
                    }

                    if (isRelevant && window.SwooPF && typeof window.SwooPF.populateCanonicalSubmission === 'function') {
                        clearTimeout(window.SwooPF_mo_timer);
                        window.SwooPF_mo_timer = setTimeout(function(){
                            isPopulating = true;
                            try { window.SwooPF.populateCanonicalSubmission(); } catch(e){}
                            setTimeout(function(){ isPopulating = false; }, 150);
                        }, 250);
                    }
                });
                mo.observe(observerTarget, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
            } catch (e) {}
        })();

        window.SwooPF = window.SwooPF || {};
        let isPopulatingInternal = false;
        window.SwooPF.populateCanonicalSubmission = function (formOrLocal) {
            if (isPopulatingInternal) return;
            isPopulatingInternal = true;
            try {
                var form = null;
                var local = null;
                if (!formOrLocal) {
                    var globalLocal = document.querySelector('.summary.entry-summary .swoo-field-groups');
                    local = globalLocal;
                    form = globalLocal ? (globalLocal.closest ? globalLocal.closest('form') : null) : null;
                    if (!form) form = document.querySelector('form.cart');
                } else {
                    if (formOrLocal.tagName && formOrLocal.tagName.toLowerCase() === 'form') {
                        form = formOrLocal;
                        local = form.querySelector('.swoo-field-groups') || document.querySelector('.swoo-field-groups[data-product-id]');
                    } else {
                        local = formOrLocal;
                        form = local.closest ? local.closest('form') : document.querySelector('form.cart');
                    }
                }
                if (!local) return;
                const $local = $(local);
                const pairs = buildSerializedPairsForContainer($local);
                if (form && pairs.length) {
                    $(form).find('.swoo-submitted-temp').remove();
                    pairs.forEach(function(item){
                        $('<input>').attr({'type':'hidden','name': item.name, 'value': item.value, 'class': 'swoo-submitted-temp'}).appendTo(form);
                    });
                    setTimeout(function(){ $(form).find('.swoo-submitted-temp').remove(); }, 2000);
                }

                var globalRoot = document.getElementById('swoo-hidden-submitted');
                if (globalRoot) {
                    while (globalRoot.firstChild) globalRoot.removeChild(globalRoot.firstChild);
                    pairs.forEach(function(p){
                        var inp = document.createElement('input');
                        inp.type = 'hidden';
                        inp.name = p.name;
                        inp.value = p.value;
                        globalRoot.appendChild(inp);
                    });
                }
            } catch (e) {
            } finally {
                setTimeout(function(){ isPopulatingInternal = false; }, 150);
            }
        };

    });
})(jQuery);
